import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBarsStaggered } from 'react-icons/fa6';
import edge from './Homepage/Images/edge.png';
import { AiOutlineGlobal } from "react-icons/ai";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  // Prevent body scroll when sidebar is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <>
    <div className='z-50 sticky top-0'>
      {/* Sticky Navbar - Always Sticky */}
      <nav className=" bg-[#202020] shadow-2xl ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16 md:h-20">
            
            {/* Logo + Nav Links (Desktop) */}
            <div className="flex items-center space-x-8">
              <Link to="/" className="hover:scale-105 transition-transform duration-300">
                <img src={edge} alt="Edge" className="h-10 w-auto" />
              </Link>

              {/* Desktop Nav Links - WHITE TEXT + SMOOTH ZOOM HOVER + NO UNDERLINE */}
              <ul className="hidden md:flex space-x-8 mb-0 pl-0">
                <li>
                  <Link 
                    to="/product" 
                    className="text-white text-sm font-medium hover:scale-110 hover:text-gray-200 transform transition-all duration-300 ease-in-out no-underline hover:no-underline block py-2"
                  >
                    Our Products
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/contact" 
                    className="text-white text-sm font-medium hover:scale-110 hover:text-gray-200 transform transition-all duration-300 ease-in-out no-underline hover:no-underline block py-2"
                  >
                    Contact Us
                  </Link>
                </li>
                <li>
                  <Link 
                    to="/about" 
                    className="text-white text-sm font-medium hover:scale-110 hover:text-gray-200 transform transition-all duration-300 ease-in-out no-underline hover:no-underline block py-2"
                  >
                    About Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Right Side: Lang + Login + Register + Hamburger */}
            <div className="flex items-center space-x-4">
              {/* Language */}
              <div className="hidden md:flex items-center text-white text-sm space-x-1 ">
                <AiOutlineGlobal className='' size={20}/>
                <span>Eng</span>
              </div>

              {/* Log In - WHITE + ZOOM HOVER */}
              <a
                href="https://dashboard.edgepay.in/login"
                target="_blank"
                rel="noopener noreferrer"
                className="hidden md:block text-white text-sm font-medium hover:scale-110 hover:text-gray-200 transform transition-all duration-300 ease-in-out no-underline hover:no-underline py-2"
              >
                Log In
              </a>

              {/* Register Button - WHITE TEXT + ZOOM */}
              <a
                href="https://dashboard.edgepay.in/register"
                target="_blank"
                rel="noopener noreferrer"
                className="hidden md:block"
              >
                <button className="bg-[#565656] hover:scale-105 text-white px-6 py-2.5 rounded-lg text-sm font-semibold transform transition-all duration-300 ease-in-out shadow-md hover:shadow-xl hover:border-gray-600">
                  Register
                </button>
              </a>

              {/* Hamburger Icon (Mobile) */}
              <button
                onClick={toggleSidebar}
                className="md:hidden text-white p-2 hover:scale-110 transition-transform duration-300"
              >
                <FaBarsStaggered className="w-6 h-6" />
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Sidebar - SMOOTH LEFT TO RIGHT */}
      <div
        className={`fixed inset-y-0 left-0 z-[9999] w-72 bg-gradient-to-b from-black to-[#202020] transform -translate-x-full md:hidden transition-transform duration-500 ease-in-out ${
          isOpen ? 'translate-x-0' : ''
        } shadow-2xl`}
      >
        <div className="p-8">
          <img src={edge} alt="Edge" className="h-12 mb-12" />
          <ul className="space-y-8">
            <li>
              <Link 
                to="/" 
                onClick={toggleSidebar}
                className="text-white text-xl font-semibold hover:scale-110 hover:text-gray-200 block transform transition-all duration-300 ease-in-out py-3 no-underline"
              >
                Home
              </Link>
            </li>
            <li>
              <Link 
                to="/about" 
                onClick={toggleSidebar}
                className="text-white text-xl font-semibold hover:scale-110 hover:text-gray-200 block transform transition-all duration-300 ease-in-out py-3 no-underline"
              >
                About Us
              </Link>
            </li>
            <li>
              <Link 
                to="/product" 
                onClick={toggleSidebar}
                className="text-white text-xl font-semibold hover:scale-110 hover:text-gray-200 block transform transition-all duration-300 ease-in-out py-3 no-underline"
              >
                Our Products
              </Link>
            </li>
            <li>
              <Link 
                to="/contact" 
                onClick={toggleSidebar}
                className="text-white text-xl font-semibold hover:scale-110 hover:text-gray-200 block transform transition-all duration-300 ease-in-out py-3 no-underline"
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>

      {/* Overlay - bg-black/50 + NO SCROLL */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-[999] md:hidden"
          onClick={toggleSidebar}
        />
      )}
      </div>
    </>
  );
};

export default Navbar;